import { render, staticRenderFns } from "./ProductInspection.vue?vue&type=template&id=b9e9d5c8&scoped=true&"
import script from "./ProductInspection.vue?vue&type=script&lang=js&"
export * from "./ProductInspection.vue?vue&type=script&lang=js&"
import style0 from "./ProductInspection.vue?vue&type=style&index=0&id=b9e9d5c8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e9d5c8",
  null
  
)

export default component.exports